import $ from 'cash-dom';
import anime from "animejs/lib/anime.es.js";

export const headerComponent = () => {
    const showButton = $('#menu-show').get(0);
    const hideButton = $('#menu-hide').get(0);
    const headerBackground = $('#header-bg').get(0);
    const $menu = $('#menu-bg');
    const menuBackground = $menu.get(0);
    const $links = $menu.find('a');

    let isVisible = false;

    const animateMenuHeight = (height) => anime({
        targets: menuBackground,
        height,
        easing: 'easeInSine',
        duration: 600,
    });

    const animateMenuButtons = (toHide, toShow) => {
        toShow.style.opacity = '0';
        toShow.style.display = 'none';

        toHide.style.opacity = '1';
        toHide.style.display = 'block';

        anime.timeline({
            easing: 'easeInOutSine',
            duration: 200,
        })
            .add({
                targets: toHide,
                opacity: '0',
                complete() {
                    toHide.style.display = 'none';
                    toShow.style.display = 'block';
                },
            })
            .add({
                targets: toShow,
                opacity: '1',
            });
    }

    const onScroll = (scrollY) => {
        headerBackground.style.opacity = Math.max(
            0,
            Math.min(
                1,
                scrollY / headerBackground.clientHeight)
        ).toString();
    };

    const showMenu = () => {
        isVisible = true;
        animateMenuHeight('100%');
        // animateMenuButtons(showButton, hideButton);
    };

    const hideMenu = () => {
        isVisible = false;
        animateMenuHeight('0');
        // animateMenuButtons(hideButton, showButton);
    };

    showButton.onclick = () => !isVisible && showMenu();
    hideButton.onclick = () => isVisible && hideMenu();
    $links.each((_, link) =>
        link.addEventListener('click', () => {
            isVisible && hideMenu();
        })
    );
};
